import { devices } from '@helpers/utils.js';
import {
  MediaReplaceButton,
  MediaRemoveButton,
} from '@components/media-upload';

const {
  i18n: { __ },
  blockEditor: { MediaUpload, MediaUploadCheck },
  components: { PanelBody, Button, ColorPalette },
} = wp;

const BackgroundTypeImageAndColor = ({
  backgroundImageAndColorOptions,
  setAttributes,
}) => {
  const colors = wp.data.select('core/block-editor').getSettings().colors;
  const onChangeBackgroundColor = (
    paramValue,
    paramDeviceType,
    paramBackgroundImageAndColorOptions,
    paramBackgroundColor,
  ) => {
    setAttributes({
      backgroundImageAndColorOptions: {
        ...paramBackgroundImageAndColorOptions,
        [paramDeviceType]: {
          ...backgroundImageAndColorOptions[paramDeviceType],
          settings: {
            ...paramBackgroundImageAndColorOptions[paramDeviceType].settings,
            [paramBackgroundColor]: paramValue,
          },
        },
      },
    });
  };

  const changeBackgroundImage = (
    url,
    alt,
    paramDeviceType,
    paramBackgroundImageOptions,
  ) => {
    setAttributes({
      backgroundImageAndColorOptions: {
        ...paramBackgroundImageOptions,
        [paramDeviceType]: {
          ...backgroundImageAndColorOptions[paramDeviceType],
          settings: {
            ...paramBackgroundImageOptions[paramDeviceType].settings,
            url,
            alt,
          },
        },
      },
    });
  };

  return (
    <>
      {devices.map((device, index) => {
        const deviceType = device.type;
        const deviceLabel = device.label;
        const { url, alt } =
          backgroundImageAndColorOptions[deviceType].settings;

        return (
          <PanelBody
            title={deviceLabel}
            initialOpen={index === 0}
            key={deviceType}
          >
            <ColorPalette
              label={__('Select Background Color', 'b3rg')}
              colors={colors}
              enableAlpha
              value={
                backgroundImageAndColorOptions[deviceType].settings
                  .backgroundColor
              }
              onChange={(newValue) => {
                onChangeBackgroundColor(
                  newValue,
                  deviceType,
                  backgroundImageAndColorOptions,
                  'backgroundColor',
                );
              }}
            />
            <MediaUploadCheck>
              <MediaUpload
                allowedType={['image']}
                value={url}
                onSelect={(img) => {
                  const { url = '', alt = '' } = img;
                  changeBackgroundImage(
                    url,
                    alt,
                    deviceType,
                    backgroundImageAndColorOptions,
                  );
                }}
                render={({ open }) => (
                  <div className="media-upload image-upload">
                    {url && (
                      <div className="upload-buttons-wrapper">
                        <MediaReplaceButton onClick={open} />
                        <MediaRemoveButton
                          onClick={() => {
                            changeBackgroundImage(
                              '',
                              '',
                              deviceType,
                              backgroundImageAndColorOptions,
                            );
                          }}
                        />
                      </div>
                    )}
                    {!url && (
                      <Button
                        className="media-button upload-button"
                        onClick={open}
                      >
                        {__('Upload Image', 'b3rg')}
                      </Button>
                    )}
                    {url && (
                      <div
                        className="image-thumb-wrapper"
                        onClick={open}
                        onKeyUp={open}
                        role="button"
                        tabIndex="0"
                      >
                        <img className="image-thumb" src={url} alt={alt} />
                      </div>
                    )}
                  </div>
                )}
              ></MediaUpload>
            </MediaUploadCheck>
          </PanelBody>
        );
      })}
    </>
  );
};

export default BackgroundTypeImageAndColor;
